import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import {
  useCartFloatingIcon,
  CartFloatingIconProps,
} from './useCartFloatingIcon'
import styles from './CartFloatingIcon.module.scss'

const CartFloatingIcon: React.FC<CartFloatingIconProps> = (
  props: CartFloatingIconProps
) => {
  const { restaurantName, isAnimating, numberOfItems } =
    useCartFloatingIcon(props)

  const containerClasses = `${styles['cart-floating-icon-container']} ${
    isAnimating ? styles.bump : ''
  }`

  return (
    <Link to={`/${restaurantName}/Cart`}>
      <div className={containerClasses}>
        {numberOfItems > 0 && (
          <span className={styles['items-count']}>{numberOfItems}</span>
        )}
        <i className='bi bi-cart4'></i>
      </div>
    </Link>
  )
}

export default memo(CartFloatingIcon)
